import _ from 'underscore';
import { updateCreativeSync } from './actions';

export default function CreativeService(
  $location,
  $ngRedux,
  $sce,
  $state,
  CreativeDemoFactory,
  CreativeFromParamFactory,
  SitesService
) {
  const vm = this;

  vm.creative = {};

  vm.creativeGroupName = null;
  vm.defaultCreative = {};
  vm.creativeWithDefaults = creativeWithDefaults;
  vm.instantPlaySupported = instantPlaySupported;
  vm.isCreativeInstantPlay = isCreativeInstantPlay;
  vm.resetCreative = resetCreative;
  vm.getCreative = getCreative;
  vm.getCreativeAttr = getCreativeAttr;
  vm.setCreative = setCreative;
  vm.set = set;
  vm.setAttrs = setAttrs;
  vm.setBehavior = setBehavior;
  vm.setDefaultCreative = setDefaultCreative;
  vm.trustedMediaUrl = trustedMediaUrl;
  vm.setVideoAttributes = setVideoAttributes;
  vm.ensureProtocol = ensureProtocol;
  vm.creativeIsActive = creativeIsActive;
  vm.adType = adType;
  vm.isCreativeIsi = isCreativeIsi;
  vm.isCreativeInstreamVideo = isCreativeInstreamVideo;
  vm.isEnhancedAd = isEnhancedAd;
  vm.isCreativeCaptioned = isCreativeCaptioned;
  vm.isFromDco = isFromDco;
  vm.updateLocationWithBehaviors = updateLocationWithBehaviors;

  return vm;

  function updateStore(creativeData) {
    // Prevent any store updates
    return;
  }

  function creativeIsActive(creative) {
    return creative.id === vm.creative.id && creative.name === vm.creative.name;
  }

  function ensureProtocol() {
    if (vm.creative.mediaUrl && !vm.creative.mediaUrl.match('//')) {
      vm.creative.mediaUrl = 'https://' + vm.creative.mediaUrl;
    }
  }
  // YUCK. TODO use lodash's _.merge (which is deep)
  function creativeWithDefaults() {
    return {
      creative: _.extend(
        JSON.parse(JSON.stringify(vm.defaultCreative)),
        JSON.parse(JSON.stringify(vm.creative))
      )
    };
  }

  function setDefaultCreative(partner) {
    vm.defaultCreative = CreativeDemoFactory.getDemo($state.params.id);
    vm.creative.action = vm.defaultCreative.action;
    vm.creative.isiText = vm.defaultCreative.isiText;
    vm.creative.isiAutoscroll = vm.defaultCreative.isiAutoscroll;
    vm.creative.behaviors = {};

    // An outstream creative doesn't have most of the necessary attributes so
    // the "default" attributes are subbed into place.
    if (vm.creative.action === 'outstream') {
      setCreative(vm.defaultCreative);
      return;
    }

    if (partner && partner.name !== 'Sharethrough') {
      vm.defaultCreative.brandLogoUrl = '';
      vm.defaultCreative.headline = 'Headline';

      /* we already override DSP video ad thumbnails, so don't
           over-over-ride here */
      if (
        !(
          partner.partnerType === 'DSP' &&
          vm.defaultCreative.action === 'hosted-video'
        )
      ) {
        vm.defaultCreative.thumbnailUrl = '/generic_brand_logo.png';
      }

      vm.defaultCreative.description = 'This is the description.';
      vm.defaultCreative.advertiser = partner.name;
      vm.defaultCreative.mediaUrl = 'https://www.example.com';
    }
  }

  function resetCreative() {
    vm.creative = CreativeFromParamFactory.build();
    updateStore(vm.creative);
  }

  function getCreative() {
    return vm.creative;
  }

  function set(attr, value) {
    // Prevent modifications
    return;
  }

  function setBehavior(behavior, value) {
    // Prevent modifications
    return;
  }

  function getCreativeAttr(attr) {
    return vm.creative[attr];
  }

  function setCreative(creative) {
    // Only allow reading, not setting
    vm.creative = creative;
    updateLocationWithBehaviors();
  }

  function updateLocationWithBehaviors() {
    if (!vm.creative.behaviors || Object.keys(vm.creative.behaviors).length === 0) {
      return;
    }

    const params = Object.entries($location.search()).reduce((params, [key, value]) => {
      params[key] = value;
      return params;
    }, {});

    const nonBehaviorParams = Object.entries(params).filter(([key, ]) => {
      return !['str_modify', 'behaviors'].includes(key);
    }).map(([key, value]) => {
      return `${key}=${value}`;
    }).join('&');

    const creativeBehaviors = Object.keys(vm.creative.behaviors);

    const urlBehaviors = (params['behaviors'] || '').split(',').filter(behavior => {
      return behavior && !creativeBehaviors.includes(behavior);
    });

    const enabledBehaviors = creativeBehaviors.filter(behavior => vm.creative.behaviors[behavior]);
    const behaviors = enabledBehaviors.concat(urlBehaviors);

    if (behaviors.length > 0) {
      if (nonBehaviorParams) {
        $location.search(`${nonBehaviorParams}&str_modify=true&behaviors=${behaviors.join(',')}`);
      } else {
        $location.search(`str_modify=true&behaviors=${behaviors.join(',')}`);
      }
    } else {
      $location.search(nonBehaviorParams);
    }
  }

  function setAttrs(creativeData) {
    // Prevent modifications
    return;
  }

  function setVideoAttributes(_creative) {
    // we can't just set creative because it overrides anything a user has
    // filled in since they first uploaded the video
    vm.creative.id = _creative.id;
    vm.creative.status = _creative.status;
    vm.creative.mediaUrl = _creative.mediaUrl;
    vm.creative.instantPlayMobileCount = _creative.instantPlayMobileCount;
    vm.creative.instantPlayMobileUrl = _creative.instantPlayMobileUrl;
    vm.creative.videoAspectRatio = _creative.videoAspectRatio;
    vm.creative.instantPlayMobileWidth = _creative.instantPlayMobileWidth;
    vm.creative.instantPlayMobileHeight = _creative.instantPlayMobileHeight;
    vm.creative.videoLength = _creative.videoLength;
  }

  function trustedMediaUrl() {
    return $sce.trustAsResourceUrl(vm.creative.mediaUrl);
  }

  function instantPlaySupported(site) {
    return SitesService.isSiteEnabled(site, isCreativeInstantPlay());
  }

  function isCreativeInstantPlay() {
    const { creative: { action, forceClickToPlay } } = vm;
    var isVideo = action === 'hosted-video';

    var notForceClickToPlay = !forceClickToPlay;
    return isVideo && notForceClickToPlay;
  }

  function isCreativeInstreamVideo() {
    return vm.creative.action === 'instream-video';
  }

  function isCreativeIsi() {
    return vm.creative.isiText !== undefined && vm.creative.isiText !== null;
  }

  function isCreativeCaptioned() {
    return !!vm.creative.srtFileUrl;
  }

  // TODO: this will need to be smarter once we start creating EA Demo Ad types
  function isEnhancedAd() {
    return vm.creative.action === 'banner';
  }

  function isFromDco() {
    return vm.creative.dcoUrl;
  }

  function adType(creative) {
    switch (creative.action) {
      case 'banner':
        return 'Enhanced Display';
      case 'scroller':
        return 'Scroller';
      case 'outstream':
        return 'Standard Outstream';
      case 'instream-video':
        return 'Instream Video';
      case 'hosted-video':
        // isiText can be null
        if (creative.isiText == undefined) {
          return 'Native Outstream';
        }
        return 'ISI Video';
      case 'clickout':
        if (creative.dcoUrl) {
          return 'Dynamic Native';
        }
        if (creative.isiText == undefined) {
          return 'Native Display';
        }
        return 'ISI Display';
      default:
        return undefined;
    }
  }
}

CreativeService.$inject = [
  '$location',
  '$ngRedux',
  '$sce',
  '$state',
  'CreativeDemoFactory',
  'CreativeFromParamFactory',
  'SitesService'
];
